import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFaireDirectFirstOrderIncentive } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectFirstOrderIncentive/useFaireDirectFirstOrderIncentive";
import { Column, Flex, HorizontalLine } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";
import { useSettingFirstOrderIncetiveForFaireDirectLoggedOut } from "@faire/retailer/settings/useSettingFirstOrderIncetiveForFaireDirectLoggedOut";
import { Perk } from "@faire/retailer/views/faire-direct/sections/PerksSection/__internal__/Perk";
import { getPerkValues } from "@faire/retailer/views/faire-direct/sections/PerksSection/__internal__/PerkValues";
export var PerksSection = function() {
    var isFoiForFD = useSettingFirstOrderIncetiveForFaireDirectLoggedOut();
    var isMobile = useViewport().isMobile;
    var _useFaireDirectFirstOrderIncentive = useFaireDirectFirstOrderIncentive(), isFaireDirectCreditPercentageBased = _useFaireDirectFirstOrderIncentive.isFaireDirectCreditPercentageBased, formattedPercentageBasedNumber = _useFaireDirectFirstOrderIncentive.formattedPercentageBasedNumber, formattedMaxPercentageDiscountAmount = _useFaireDirectFirstOrderIncentive.formattedMaxPercentageDiscountAmount, formattedFixedBasedAmount = _useFaireDirectFirstOrderIncentive.formattedFixedBasedAmount;
    var perkValues = getPerkValues({
        isFaireDirectCreditPercentageBased: isFaireDirectCreditPercentageBased,
        formattedIncentiveAmount: formattedFixedBasedAmount,
        formattedPercentageBasedDiscount: formattedPercentageBasedNumber,
        formattedMaximumPercentageDiscount: formattedMaxPercentageDiscountAmount,
        isFoiForFDDiscount: isFoiForFD
    });
    return /*#__PURE__*/ _jsxs(Column, {
        align: "center",
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                height: "9x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "pageHeaderSerifRegular",
                align: "center",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "fi49KE",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Why shop us through Faire?"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            /*#__PURE__*/ _jsx(HorizontalLine, {
                width: "120px"
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "6x"
            }),
            /*#__PURE__*/ _jsx(ResponsiveContainer, {
                children: perkValues.map(function(value, index) {
                    return /*#__PURE__*/ _jsx(Perk, {
                        value: value,
                        index: index
                    }, index);
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: isMobile ? "9x" : 96
            })
        ]
    });
};
var ResponsiveContainer = styled(Flex).attrs({
    direction: {
        mobileAndAbove: "column",
        tabletAndAbove: "row"
    }
}).withConfig({
    componentId: "sc-35bc3ed1-0"
})([
    ""
]);
